import { __exportAll } from "../_virtual/_rolldown/runtime.js";
import _ from "underscore";
import { ClientType, FulfillmentMethodHelper, IntegrationSystem, LocationPaymentType, LocationState, OrderChannel } from "@biteinc/enums";
import { I9nSchemaBySystem, systemIsFulfillment, systemIsMarketing, systemIsPos } from "@biteinc/common";
//#region src/utils/location_utils.ts
var location_utils_exports = /* @__PURE__ */ __exportAll({
	attachIntegrations: () => attachIntegrations,
	everyFulfillmentSchemaHas: () => everyFulfillmentSchemaHas,
	everyPosSchemaHas: () => everyPosSchemaHas,
	getActiveFulfillmentMethods: () => getActiveFulfillmentMethods,
	getAllDiningOptions: () => getAllDiningOptions,
	getDiningOption: () => getDiningOption,
	getEnabledDiningOptions: () => getEnabledDiningOptions,
	getFulfillmentI9nIds: () => getFulfillmentI9nIds,
	getFulfillmentI9nSchemas: () => getFulfillmentI9nSchemas,
	getFulfillmentPartialI9ns: () => getFulfillmentPartialI9ns,
	getFullCampusCardI9n: () => getFullCampusCardI9n,
	getFullCompCardI9n: () => getFullCompCardI9n,
	getFullFulfillmentI9n: () => getFullFulfillmentI9n,
	getFullI9nWithId: () => getFullI9nWithId,
	getFullI9nsWithPredicate: () => getFullI9nsWithPredicate,
	getFullI9nsWithSchemaType: () => getFullI9nsWithSchemaType,
	getFullLoyaltyEarnerI9n: () => getFullLoyaltyEarnerI9n,
	getFullLoyaltyI9n: () => getFullLoyaltyI9n,
	getFullLoyaltyOrLoginEarnerI9n: () => getFullLoyaltyOrLoginEarnerI9n,
	getFullPaymentI9n: () => getFullPaymentI9n,
	getFullPosI9ns: () => getFullPosI9ns,
	getFullPosI9nsWithVendorId: () => getFullPosI9nsWithVendorId,
	getFullTableTrackerI9n: () => getFullTableTrackerI9n,
	getI9nSchemaWithType: () => getI9nSchemaWithType,
	getIsLive: () => getIsLive,
	getMarketingI9nIds: () => getMarketingI9nIds,
	getPartialI9ns: () => getPartialI9ns,
	getPaymentI9nSchema: () => getPaymentI9nSchema,
	getPosI9nIds: () => getPosI9nIds,
	getPosI9nIdsWithVendorId: () => getPosI9nIdsWithVendorId,
	getPosI9nSchemas: () => getPosI9nSchemas,
	getPosPartialI9ns: () => getPosPartialI9ns,
	hasAssignedFutureOrderingKioskDiningOption: () => hasAssignedFutureOrderingKioskDiningOption,
	hasFulfillmentI9n: () => hasFulfillmentI9n,
	hasI9ns: () => hasI9ns,
	hasIntegrationWithSystem: () => hasIntegrationWithSystem,
	hasMarketingI9n: () => hasMarketingI9n,
	hasPosI9n: () => hasPosI9n,
	hasSmsNotifierI9n: () => hasSmsNotifierI9n,
	posSupportsFutureOrders: () => posSupportsFutureOrders,
	requiresManualTaxCalculation: () => requiresManualTaxCalculation,
	setIntegrations: () => setIntegrations,
	syncsModelsWithType: () => syncsModelsWithType,
	takesPayment: () => takesPayment
});
async function attachIntegrations(location, Integration) {
	if (location.integrations) return;
	if (!location.hasI9ns()) {
		location.setIntegrations([]);
		return;
	}
	const integrations = await Integration.find({ locationId: location.id });
	location.setIntegrations(integrations);
}
function getActiveFulfillmentMethods(data, clientType) {
	return data.activeFulfillmentMethods.filter((activeFulfillmentMethod) => {
		if (data.orderChannel === OrderChannel.Kiosk || data.orderChannel === OrderChannel.Flash) {
			if (clientType === ClientType.Flash) return FulfillmentMethodHelper.orderChannel(activeFulfillmentMethod) === OrderChannel.Flash;
			return FulfillmentMethodHelper.orderChannel(activeFulfillmentMethod) === OrderChannel.Kiosk;
		}
		return FulfillmentMethodHelper.orderChannel(activeFulfillmentMethod) === data.orderChannel;
	});
}
function getAllDiningOptions(data) {
	return [...data.flashDiningOptions, ...data.kioskDiningOptions];
}
function getDiningOption(data, fulfillmentMethod) {
	return _.findWhere(getAllDiningOptions(data), { fulfillmentMethod });
}
function getEnabledDiningOptions(data, clientType) {
	const enabledDiningOptions = (ClientType.Flash === clientType ? data.flashDiningOptions : data.kioskDiningOptions).filter((diningOption) => {
		return diningOption.isEnabled;
	});
	const assignedDiningOptions = enabledDiningOptions.filter((diningOption) => {
		return data.assignedFulfillmentMethods.includes(diningOption.fulfillmentMethod);
	});
	if (!assignedDiningOptions.length) return enabledDiningOptions;
	const activeDiningOptions = assignedDiningOptions.filter((diningOption) => {
		return data.activeFulfillmentMethods.includes(diningOption.fulfillmentMethod) || diningOption.futureOrdersEnabled;
	});
	return activeDiningOptions.length ? activeDiningOptions : assignedDiningOptions;
}
function getFulfillmentI9nIds(data) {
	return getPartialI9ns(data).filter(({ system }) => systemIsFulfillment(system)).map(({ _id }) => _id);
}
function getFullCampusCardI9n(integrations) {
	return _.first(getFullI9nsWithSchemaType(integrations, "campus-card"));
}
/**
* Narrows an integration by its schema's type. The schema map correlates each system with
* exactly one schema type, but the compiler cannot see that relationship, so this guard is
* the single narrow point that all the category getters below share.
*/
function i9nHasSchemaType(i9n, type) {
	return i9n.getI9nSchema().type === type;
}
function getFullCompCardI9n(integrations) {
	return _.first(getFullI9nsWithSchemaType(integrations, "comp-card"));
}
function getFullI9nsWithPredicate(integrations, predicate) {
	if (!integrations) throw new Error("No integrations set");
	return integrations.filter(predicate);
}
/** All integrations whose schema is of the given type, narrowed to that type's system union. */
function getFullI9nsWithSchemaType(integrations, type) {
	if (!integrations) throw new Error("No integrations set");
	return integrations.filter((i9n) => {
		return i9nHasSchemaType(i9n, type);
	});
}
function getFullFulfillmentI9n(integrations) {
	return _.first(getFullI9nsWithSchemaType(integrations, "fulfillment"));
}
function getFullPaymentI9n(integrations) {
	return _.first(getFullI9nsWithSchemaType(integrations, "kiosk-payment"));
}
function getFullPosI9ns(integrations) {
	return getFullI9nsWithSchemaType(integrations, "pos");
}
function getFullTableTrackerI9n(integrations) {
	return _.first(getFullI9nsWithSchemaType(integrations, "table-tracker"));
}
function getPosI9nIdsWithVendorId(integrations, vendorId) {
	return getFullPosI9nsWithVendorId(integrations, vendorId).map((i9n) => i9n.id);
}
function getFullPosI9nsWithVendorId(integrations, vendorId) {
	return getFullPosI9ns(integrations).filter((i9n) => {
		return i9n.data.vendorId.equals(vendorId);
	});
}
function getFullI9nWithId(integrations, i9nId) {
	if (!integrations) throw new Error("No integrations set");
	return integrations.find((i9n) => {
		return i9n.id.equals(i9nId);
	});
}
function getFullLoyaltyI9n(integrations) {
	return _.first(getFullI9nsWithSchemaType(integrations, "loyalty"));
}
function getFullLoyaltyEarnerI9n(integrations) {
	return _.first(getFullI9nsWithSchemaType(integrations, "loyalty-earner"));
}
function getFullLoyaltyOrLoginEarnerI9n(integrations) {
	const loyaltyI9n = getFullLoyaltyI9n(integrations);
	const loyaltyI9nEarner = getFullLoyaltyEarnerI9n(integrations);
	if (!loyaltyI9n && !loyaltyI9nEarner) return;
	if (loyaltyI9nEarner) {
		const loyaltyEarnerSchema = loyaltyI9nEarner.getI9nSchema();
		if ("allowUserToLogIn" in loyaltyEarnerSchema && loyaltyEarnerSchema.allowUserToLogIn) return loyaltyI9nEarner;
	}
	return loyaltyI9n;
}
function getIsLive(data) {
	return data.state === LocationState.Live;
}
function getPartialI9ns(data) {
	return Object.values(data.integrationById);
}
function getPaymentI9nSchema(data) {
	return getI9nSchemaWithType(data, "kiosk-payment");
}
function getI9nSchemaWithType(data, type) {
	return getPartialI9ns(data).map(({ system }) => {
		return I9nSchemaBySystem[system];
	}).find((i9nSchema) => {
		return i9nSchema.type === type;
	});
}
function hasAssignedFutureOrderingKioskDiningOption(data) {
	return !!data.kioskDiningOptions.find((diningOption) => {
		return diningOption.isEnabled && data.assignedFulfillmentMethods.includes(diningOption.fulfillmentMethod) && diningOption.futureOrdersEnabled;
	});
}
/**
* @returns true if the location has a fulfillment integration; false otherwise.
*/
function hasFulfillmentI9n(data) {
	return !!getI9nSchemaWithType(data, "fulfillment");
}
function hasI9ns(data) {
	return getPartialI9ns(data).length > 0;
}
function getMarketingI9nIds(data) {
	return getPartialI9ns(data).filter(({ system }) => systemIsMarketing(system)).map(({ _id }) => _id);
}
function hasMarketingI9n(data) {
	return !!getI9nSchemaWithType(data, "marketing");
}
function getPosPartialI9ns(data) {
	return getPartialI9ns(data).filter(({ system }) => {
		return systemIsPos(system);
	});
}
function getPosI9nIds(data) {
	return getPosPartialI9ns(data).map(({ _id }) => _id);
}
function hasIntegrationWithSystem(data, system) {
	return !!getPartialI9ns(data).find((partialI9n) => {
		return partialI9n.system === system;
	});
}
/**
* @returns true if the location has a pos integration; false otherwise.
*/
function hasPosI9n(data) {
	return getPosPartialI9ns(data).length > 0;
}
function hasSmsNotifierI9n(data) {
	return !!getI9nSchemaWithType(data, "sms-notifier");
}
function takesPayment(data) {
	return data.paymentType !== LocationPaymentType.CashierOnly;
}
function getPosI9nSchemas(data) {
	return getPosPartialI9ns(data).map(({ system }) => {
		return I9nSchemaBySystem[system];
	});
}
function everyPosSchemaHas(data, property, value = true) {
	const posI9nSchemas = getPosI9nSchemas(data);
	return posI9nSchemas.length > 0 && posI9nSchemas.every((posI9nSchema) => {
		return posI9nSchema[property] === value;
	});
}
function getFulfillmentPartialI9ns(data) {
	return getPartialI9ns(data).filter(({ system }) => systemIsFulfillment(system));
}
function getFulfillmentI9nSchemas(data) {
	return getFulfillmentPartialI9ns(data).map(({ system }) => {
		return I9nSchemaBySystem[system];
	});
}
function everyFulfillmentSchemaHas(data, property, value = true) {
	const fulfillmentI9nSchemas = getFulfillmentI9nSchemas(data);
	return fulfillmentI9nSchemas.length > 0 && fulfillmentI9nSchemas.every((fulfillmentI9nSchema) => {
		return fulfillmentI9nSchema[property] === value;
	});
}
function posSupportsFutureOrders(data, integrations) {
	if (everyFulfillmentSchemaHas(data, "supportsFutureOrders")) return true;
	const posPartialI9ns = getPosPartialI9ns(data);
	if (!posPartialI9ns.length) return false;
	return posPartialI9ns.every((partialI9n) => {
		if (!I9nSchemaBySystem[partialI9n.system].supportsFutureOrders) return false;
		if (partialI9n.system === IntegrationSystem.Simphony) return !!getFullI9nForSystem(IntegrationSystem.Simphony, integrations)?.data.sendFutureOrdersAsap;
		return true;
	});
}
function getFullI9nForSystem(system, integrations) {
	if (!integrations) throw new Error("No integrations set");
	return integrations.find((i9n) => {
		return i9n.data.system === system;
	});
}
function requiresManualTaxCalculation(data, integrationIds) {
	if (!integrationIds.length) return true;
	if (!getPosPartialI9ns(data).length) return true;
	return false;
}
function setIntegrations(location, integrations) {
	if (!integrations) throw new Error("Must set integrations");
	location.integrations = integrations;
}
function syncsModelsWithType(data, integrations, modelType, throwOnUnsyncableModelType = false) {
	if (hasPosI9n(data)) return getFullPosI9ns(integrations).some((i9n) => {
		return i9n.syncsModelsWithType(modelType, throwOnUnsyncableModelType);
	});
	return false;
}
//#endregion
export { attachIntegrations, everyFulfillmentSchemaHas, everyPosSchemaHas, getActiveFulfillmentMethods, getAllDiningOptions, getDiningOption, getEnabledDiningOptions, getFulfillmentI9nIds, getFulfillmentI9nSchemas, getFulfillmentPartialI9ns, getFullCampusCardI9n, getFullCompCardI9n, getFullFulfillmentI9n, getFullI9nWithId, getFullI9nsWithPredicate, getFullI9nsWithSchemaType, getFullLoyaltyEarnerI9n, getFullLoyaltyI9n, getFullLoyaltyOrLoginEarnerI9n, getFullPaymentI9n, getFullPosI9ns, getFullPosI9nsWithVendorId, getFullTableTrackerI9n, getI9nSchemaWithType, getIsLive, getMarketingI9nIds, getPartialI9ns, getPaymentI9nSchema, getPosI9nIds, getPosI9nIdsWithVendorId, getPosI9nSchemas, getPosPartialI9ns, hasAssignedFutureOrderingKioskDiningOption, hasFulfillmentI9n, hasI9ns, hasIntegrationWithSystem, hasMarketingI9n, hasPosI9n, hasSmsNotifierI9n, location_utils_exports, posSupportsFutureOrders, requiresManualTaxCalculation, setIntegrations, syncsModelsWithType, takesPayment };

//# sourceMappingURL=location_utils.js.map